export const SAMPLE_INTERPRETABILITY = 'sampleInterpretabilityId';
export const INTERPRETABILITY_BLOCKERS = 'sampleInterpretabilityBlockerIds';
export const TEST_VALUE = 'testValueUgG';
export const TEST_RESULT_POSITIVE = 'isResultPositive';
export const ASSAY_ABOVE = 'isAboveSpecificationLimit';
export const RESULT_PLACE = 'analysisLocationId';
export const NO_REPLY = 'NO_REPLY';
export const POSITIVE = 'POSITIVE';
export const NEGATIVE = 'NEGATIVE';
